module.exports = __webpack_public_path__ + "static/img/negative.e3be99f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/blockdash/negative.svg
// module id = 701
// module chunks = 2 3 4 5 10 11 17